<template>
  <router-link
    v-if="link?.to && link?.name"
    class="link-to"
    :to="{ name: link.to, query: $route.query }"
    target="_blank"
    rel="noopener noreferrer"
    data-png-ignore
    @click="insightsTrackWidgetLinkClick(link.name, $route.name)"
  >
    {{ link.name }}
    <IconOpen class="ml-1" />
  </router-link>
</template>

<script setup>
import { useTracking } from '@/stores/tracking/tracking';
import IconOpen from '@/assets/icon_open.svg?component';

defineProps({
  link: {
    type: Object,
    default: () => ({}),
  },
});

const { insightsTrackWidgetLinkClick } = useTracking();
</script>

<style scoped lang="less">
.link-to {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 28px;
  border-radius: 8px 0 8px 0;
  padding: 0 16px;
  background: @bg-canvas;
  cursor: pointer;
  font-size: 10px;
  font-weight: 500;
  text-align: right;
  align-content: center;
  color: @text-darkest;

  &:hover {
    color: @text-brand;

    :deep(g) {
      fill: @icon-brand;
    }
  }
}
</style>
